import { Image as ImageIcon, Upload } from "lucide-react";

export default function LogoSection({ brand, setBrand, uploadLogo, uploadingLogo, backendUrl }) {
  return (
    <section>
      <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg mb-4">
        <ImageIcon size={18} className="text-[#1f3a8a]" /> Logo strony
      </h3>
      <div className="rounded-xl border border-slate-200 p-5 bg-slate-50/50 space-y-4">
        <div className="flex items-center gap-4">
          <div className="w-24 h-24 rounded-lg bg-white border border-slate-200 flex items-center justify-center overflow-hidden">
            {brand.logo_url ? (
              <img data-testid="current-logo" src={`${backendUrl}${brand.logo_url}`} alt="Logo" className="w-full h-full object-contain" />
            ) : (
              <ImageIcon size={32} className="text-slate-300" />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-slate-800">Obecne logo</p>
            <p className="text-xs text-slate-500 break-all">{brand.logo_url || "(brak – używane domyślne /logo.jpg)"}</p>
          </div>
        </div>
        <label className={`inline-flex items-center gap-2 bg-[#1f3a8a] hover:bg-[#15296b] text-white font-semibold text-sm px-4 py-2 rounded-full cursor-pointer transition ${uploadingLogo ? "opacity-60 pointer-events-none" : ""}`}>
          <Upload size={16} />
          {uploadingLogo ? "Wgrywanie…" : "Wybierz plik i wgraj"}
          <input data-testid="logo-file-input" type="file" accept="image/*" className="hidden" onChange={(e) => uploadLogo(e.target.files?.[0])} />
        </label>
        {brand.logo_url && (
          <button type="button" onClick={() => setBrand({ ...brand, logo_url: "" })} className="ml-3 text-xs text-red-600 hover:text-red-800 font-semibold">
            Usuń niestandardowe logo (przywróć domyślne)
          </button>
        )}
        <p className="text-xs text-slate-400">Obsługiwane: PNG, JPG, WEBP, SVG, GIF (max 5 MB). Po wgraniu logo pojawia się od razu na stronie i w stopce.</p>
      </div>
    </section>
  );
}
